export function useNestedEmblaCarousel(parentEmbla, originalOptions = {}) {
  let parentIsLocked = false;
  const baseOptions = { ...(originalOptions || {}) };

  const canReInit = typeof parentEmbla?.reInit === "function";

  function lockParentScroll() {
    if (!parentEmbla || parentIsLocked) return;
    try {
      if (canReInit) {
        parentEmbla.reInit({ ...baseOptions, watchDrag: false });
        parentIsLocked = true;
        console.debug("[nested] parent locked (draggable: false)");
      } else {
        console.warn("[nested] parentEmbla.reInit is not available; cannot toggle draggable.");
      }
    } catch (err) {
      console.error("[nested] lockParentScroll error:", err);
    }
  }

  function releaseParentScroll() {
    if (!parentEmbla || !parentIsLocked) return;
    try {
      if (canReInit) {
        parentEmbla.reInit({ ...baseOptions, watchDrag: true });
        parentIsLocked = false;
        console.debug("[nested] parent released (draggable: true)");
      } else {
        console.warn("[nested] parentEmbla.reInit is not available; cannot toggle draggable.");
      }
    } catch (err) {
      console.error("[nested] releaseParentScroll error:", err);
    }
  }

  return (lock) => {
    if (lock) lockParentScroll();
    else releaseParentScroll();
  };
}